import { Button, For, Grid, HStack, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

interface ButtonGridProps<T extends string, K extends string> {
  buttons: Map<T, Map<K, boolean>>;
  label?: string;
  onClick: (type: T, label: K) => void;
  onToggleAll?: () => void;
  onToggleNone?: () => void;
}
export default function ToggleButtonGrid<T extends string, K extends string>({
  buttons,
  label,
  onClick,
  onToggleAll,
  onToggleNone,
}: Readonly<ButtonGridProps<T, K>>) {
  const hasTrue = Array.from(buttons.values()).some((inner) => Array.from(inner.values()).some((value) => value));
  const hasFalse = Array.from(buttons.values()).some((inner) => Array.from(inner.values()).some((value) => !value));
  return (
    <VStack alignItems="flex-start" paddingX={2} paddingY={3} gap={2} width="100%" backgroundColor="neutral.850">
      {label && (
        <Text fontWeight="medium" color="neutral.300">
          {label}
        </Text>
      )}
      {(onToggleNone || onToggleAll) && (
        <HStack gap={1}>
          {onToggleAll && (
            <Button variant="toggle" size="toggleS" onClick={onToggleAll} disabled={!hasTrue}>
              <FormattedMessage id="global.all" />
            </Button>
          )}
          {onToggleNone && (
            <Button variant="toggle" size="toggleS" onClick={onToggleNone} disabled={!hasFalse}>
              <FormattedMessage id="global.none" />
            </Button>
          )}
        </HStack>
      )}
      <For each={Array.from(buttons.entries())}>
        {([key, value]) => (
          <Grid templateColumns="repeat(3, 1fr)" gap={1} width="100%" key={key}>
            <For each={Array.from(value.entries())}>
              {([buttonLabel, isActive]) => (
                <Button
                  variant="toggle"
                  size="toggleM"
                  key={buttonLabel}
                  onClick={() => onClick(key, buttonLabel)}
                  data-active={isActive}
                >
                  <Text>{buttonLabel}</Text>
                </Button>
              )}
            </For>
          </Grid>
        )}
      </For>
    </VStack>
  );
}
